import { Fragment, Suspense } from 'react';
import { Outlet } from 'react-router';
import Header from '@/components/Header/index';
import { SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/Sidebar/app-sidebar';

export default function MainLayout() {
  return (
    <Fragment>
      <div className="min-h-screen bg-gray-50 dark:bg-[#1C1C1C] overflow-x-hidden">
        <SidebarProvider>
          <AppSidebar />
          <div className="w-full lg:ml-[2.5rem] lg:mt-[1.5rem] overflow-x-hidden">
            <div className="transition-all duration-300 min-h-screen">
              {/* Header */}
              <Header />

              {/* Page Content */}
              <main className="px-[1rem] md:px-[2rem] pb-[2rem]">
                <Suspense
                  fallback={
                    <div className="flex items-center justify-center h-64">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                    </div>
                  }
                >
                  <Outlet />
                </Suspense>
              </main>
            </div>
          </div>
        </SidebarProvider>
      </div>
    </Fragment>
  );
}
